



export const validatePhone = (phone) => {
    
  if(!phone) return true;

  let phone_regrex = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
  
  if(!phone_regrex.test(phone))
    return false
  
  return true;
}


export const validateAmount = (amount) => {
    
  if(!amount) return true;

  const amount_regrex = /^[0-9]*\.\d{1,2}$/;
  
  if(!amount_regrex.test(amount))
    return false
  
  return true;

}


export const validateEmail = (email) => {
    
  if(!email) return true;

  const email_regrex = /^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  
  if(!email_regrex.test(email))
    return false;
  
  return true;

}


export const formatWithMask = (digits, mask) => {
  let result = "";
  let digitIndex = 0;

  for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
    if (mask[i] === "X") {
      result += digits[digitIndex++];
    } else {
      result += mask[i];
    }
  }

  return result;
};

export const formatUSPhone = (input) => {
  if (!input) return "";

  let digits = input.replace(/\D/g, "");

  if (digits.length > 10) digits = digits.slice(0, 10);

  let mask;

  if (digits.length <= 3) mask = "XXX";
  else if (digits.length <= 6) mask = "XXX-XXX";
  else mask = "(XXX) XXX-XXXX";

  return formatWithMask(digits, mask);
};

export const validateUSPhone = (phone) => {
  if (!phone) return true;

  const phone_regex =
    /^(\(\d{3}\)\s?|\(\d{3}\)-|\d{3}[-.\s]?)?\d{3}[-.\s]?\d{4}$/;

  return phone_regex.test(phone);
};
